import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';
import { CapitalizePipe } from '@hmax-order/frontend/utils';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonConfig } from '../../interfaces';
import { ButtonGroupComponent } from '../buttons';

@Component({
  selector: 'hmax-header',
  standalone: true,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterModule,
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    TranslocoModule,
    CapitalizePipe,
    ButtonGroupComponent,
  ],
})
export class HeaderComponent {
  @Input() title = 'Title';
  @Input() titleTranslate = true;
  @Input() subtitle = '';
  @Input() subtitleTranslate = true;
  @Input() button1 = '';
  @Input() button2 = '';
  @Input() button3 = '';
  @Input() button1SvgIcon = '';
  @Input() button2SvgIcon = '';
  @Input() button3SvgIcon = '';
  @Input() button1Router = '';
  @Input() button2Router = '';
  @Input() button3Router = '';
  @Input() button1disabled = false;
  @Input() button2disabled = false;
  @Input() button3disabled = false;
  @Input() buttons!: ButtonConfig[];
  @Input() shortMargin = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() buttonClick = new EventEmitter<any>();

  private _router = inject(Router);

  /**
   * Efetuar a navegação para a rota informada
   * @param route Rota para navegação
   */
  private toNavigate(route: string): void {
    if (route) this._router.navigate([`/${route}`]);
  }

  /**
   * Verificar configuração para navegação ou emissão de um evento
   * @param button Label do botão clicado
   */
  doButtonClick(button: string): void {
    if (button === this.button1 && this.button1Router) return this.toNavigate(this.button1Router);

    if (button === this.button2 && this.button2Router) return this.toNavigate(this.button2Router);

    if (button === this.button3 && this.button3Router) return this.toNavigate(this.button3Router);

    return this.buttonClick.emit(button);
  }
}
